"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorage = void 0;
class SessionStorage {
    constructor(store) {
        this.store = store;
    }
    saveSessionData(newData) {
        this.setStoreNewData(newData);
    }
    getSavedSessionData() {
        return this.getStoredData();
    }
    removeSavedSessionData() {
        this.removeStoredSavedData();
    }
    getStoredData() {
        //TODO esto debería de definirse en cada sesión concreta
        const savedData = this.store.getItem('SessionData');
        if (savedData) {
            return savedData;
        }
        return null;
    }
    setStoreNewData(newData) {
        this.store.setItem('SessionData', newData);
    }
    removeStoredSavedData() {
        this.store.removeItem('SessionData');
    }
}
exports.SessionStorage = SessionStorage;
//# sourceMappingURL=index.js.map